import { ToastContainer as ToastWrap, Slide } from 'react-toastify'
import styled from '@emotion/styled'
import 'react-toastify/dist/ReactToastify.min.css'
import { ToastStyles } from '@nextretreat/ui-components/dist/Toast'
import { ReactComponent as CloseSVG } from 'assets/images/svg/close.svg'

const StyledContainer = styled(ToastWrap)`
  ${ToastStyles}
`

/*
 * @usage:
 *  light-  add {className: 'light'} to options to make toast light
 *  closebutton- add {className: 'hideButton'} to options to hide closebutton
 *  icon- add {icon: false} to options to remove icon from toast
 */
export const ToastContainer = () => (
  <StyledContainer
    position="bottom-left"
    autoClose={3000}
    hideProgressBar
    newestOnTop
    closeOnClick
    rtl={false}
    pauseOnHover
    transition={Slide}
    closeButton={
      <button type="button" className="Toastify__close-button">
        <CloseSVG />
      </button>
    }
  />
)
